import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

const Return = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 900, once: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const sections = t("return.sections", { returnObjects: true });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Banner – same background image as Terms */}
      <div
        className="relative h-[50vh] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://omstonearts.com/wp-content/uploads/2024/11/banner.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <h1
          data-aos="fade-up"
          className="relative text-2xl md:text-4xl font-bold font-philosopher text-white z-10"
        >
          {t("return.title")}
        </h1>
      </div>

      {/* Content – exactly the same structure as Terms */}
      <div className="px-4 md:px-10 py-12">
        <div className="space-y-8">
          {sections.map((section, index) => (
            <div
              key={index}
              data-aos="fade-up"
              className="bg-white p-8 rounded-2xl shadow"
            >
              <h2 className="text-xl font-semibold mb-3 text-gray-800">
                {section.title}
              </h2>

              {section.content && (
                <p className="text-gray-600 leading-relaxed">
                  {section.content}
                </p>
              )}

              {section.list && (
                <ul className="list-disc pl-6 mt-3 space-y-2 text-gray-600">
                  {section.list.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              )}

              {section.content1 && (
                <p className="text-gray-600 leading-relaxed mt-4">
                  {section.content1}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Return;
